export default __webpack_public_path__ + "static/media/thailand_solar.1a845dce.png";